<template>
  <section>
    <SkeletonView class="dark" height="10" width="75" />
    <SkeletonView class="dark" height="20" width="175" />
  </section>
</template>

<script>
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TeamDropdownNavItemSkeleton',
  components: {
    SkeletonView
  }
};
</script>
